import axios from "../../../../../axios";
import React, { useState } from "react";
import "./editDelete.css";

const EditReply = ({
  setReply,
  reply,
  setClickEditReply,
  setEdited,
  attachment,
  attachmentCopy,
  setAttachments1,
  clickEditReply,
  handleAttachment,
  setFilter,
  filter,
  queryId,
  setAttachments,
}) => {
  const [updateReply, setUpdateReply] = useState(reply.reply);

  const user_id = JSON.parse(localStorage.getItem("Teacher_id"));
  const getReply = async () => {
    await axios
      .get(
        `/api/v1/query/reply/get/${queryId}?_page=${1}&_limit=${5}&sortBy=-1`
      )
      .then((response) => {
        setReply(response.data.data);
      });
  };
  console.log(filter);
  const handleClick = async () => {
    if (updateReply.trim() !== '' || attachment.length > 0) {
      try {
        let res = await axios.put(`api/v1/query/reply/update/${reply.id}`, {
          user_id: user_id,
          reply: updateReply,
          attachments: attachment,
        });
        res && setEdited(true);

        getReply();
        if (res) {
          setFilter((prevState) => ({ ...prevState, page: 1 }));
          setAttachments([]);
        }
        setAttachments1((prev) => [...prev, ...attachment]);
        setClickEditReply(false);
        setReply([])
      } catch (error) {
        console.log(error);
      }
    }
  };

  return (
    <>
      <div className="my-2 gap-3 d-flex align-items-center">
        <textarea
          type="text"
          value={updateReply}
          onChange={(e) => setUpdateReply(e.target.value)}
          className="edit_interface"
        />
        <div className="yes_no gap-4 d-flex">
          <div className="done_discard" onClick={handleClick}>
            <img src="/images/done.svg" alt="" />
            <span>&nbsp; Done</span>
          </div>

          <div
            className="done_discard"
            onClick={(e) => {
              setClickEditReply(false);
              setAttachments1(attachmentCopy);
            }}
          >
            <img src="/images/discard.svg" alt="" />
            <span>&nbsp; Discard</span>
          </div>
        </div>
      </div>
    </>
  );
};
export default EditReply;
